import { createElement } from 'react'
import { ElementFactory, Serializer } from 'survey-core'
import { ReactQuestionFactory, SurveyQuestionElementBase } from 'survey-react-ui'
import { SurveyTrackingCardsQuestion, CUSTOM_TYPE } from './SurveyTrackingCardsModel'
import { SurveyTrackingCardsContent } from './SurveyTrackingCardsContent'

export function registerTrackingCards (): void {
  ElementFactory.Instance.registerElement(
    CUSTOM_TYPE,
    (name) => {
      return new SurveyTrackingCardsQuestion(name)
    }
  )

  Serializer.addClass(
    CUSTOM_TYPE,
    [
      { name: 'planOrganizationId', type: 'number', category: 'general', default: 0 },
      { name: 'priorityBasePath', type: 'string', category: 'general', default: '' }
    ],
    function () {
      return new SurveyTrackingCardsQuestion('')
    },
    'question'
  )

  ReactQuestionFactory.Instance.registerQuestion(CUSTOM_TYPE, (props) => {
    return createElement(SurveyQuestionTrackingCards, props)
  })
}

export class SurveyQuestionTrackingCards extends SurveyQuestionElementBase {
  get question (): SurveyTrackingCardsQuestion {
    return this.questionBase as SurveyTrackingCardsQuestion
  }

  get planOrganizationId (): number {
    return this.question.planOrganizationId
  }

  renderElement (): JSX.Element {
    return (
      <SurveyTrackingCardsContent
        planOrganizationId={this.question.planOrganizationId}
      />
    )
  }
}
